<template>      
    <div id="ubn" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('mating.UBN') }}</h5>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="row mt-3">
              <div class="col-8">
                <div class="input-group input-group-static null">
                    <label>{{ $t('mating.UBN') }}</label>
                    <input v-model="state.ubn" type="text" class="form-control form-control-default" disabled>
                </div>
              </div>          
          </div>
          <div class="row mt-4">
              <div class="col-4">
                <div class="input-group input-group-static null">
                  <label class="d-block mb-1" style="width: inherit;">{{ $t('mating.Male_leased') }}</label>
                  <div class="d-block mt-1">
                    <material-switch v-model="state.maleLeased" id="maleLeased" name="maleLeased" disabled />
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div id="male" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('mating.Male') }}</h5>
        <p class="mb-0 text-sm text-green" v-if="state.maleLeased">{{ $t('mating.Male_leased_from_UBN') }} {{ state.maleUBN }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">          
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('mating.Selected_male') }}</p>
              <div class="row">
                <div class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light">
                    {{ 
                      `${state.maleUBN || ''}` +
                      (state.maleStudbookNumber ? ` | ${state.maleStudbookNumber}` : '') +
                      (state.maleAnimalNumber ? ` | ${state.maleAnimalNumber}` : '') +
                      (state.maleName ? ` (${state.maleName})` : '') +
                      (state.maleInbreedFactor ? ` | ${state.maleInbreedFactor}` : '')
                    }}
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>      
      </div>
    </div>
    <div id="female" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('mating.Female') }}</h5>
        <p class="mb-0 text-sm text-green" v-if="state.maleLeased">{{ $t('mating.Male_leased_from_UBN') }} {{ state.maleUBN }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('mating.Selected_females') }}</p>
              <div class="row">
                <div v-for="female in state.mating.females" :key="female.id" class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light">
                    {{ displayText(female) }}                    
                  </div>
                </div>                
              </div>
            </div>
          </div>                 
        </div>        
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('mating.Date') }}</h5>        
        <p class="mb-0 text-sm text-green" v-if="state.maleLeased">{{ $t('mating.Male_leased_from_UBN') }} {{ state.maleUBN }}</p>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('mating.Date_from') }}</label>
                  <input v-model="state.dateFrom" type="text" class="form-control form-control-default" disabled>
              </div>
          </div>
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('mating.Date_to') }}</label>
                  <input v-model="state.dateTo" type="text" class="form-control form-control-default" disabled>
              </div>
          </div>
        </div>         
      </div>    
    </div>   
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { reactive } from 'vue'  
  
  export default {
    name: "MatingOverview",
    setup() {        

       const displayText = (f) =>       
        `${f.ubn} ${f.studbookNumber ? ` | ${f.studbookNumber}` : ''}${f.animalNumber ? ` | ${f.animalNumber}` : ''}${f.name ? ` (${f.name})` : ''} ${f.inbreedFactor != ' ' ? ` | ${f.inbreedFactor}` : ''}`


      const state = reactive ({        
        gets: [],
        mating: [],

        id: '',
        dateFrom: '',
        dateTo: '',
        inbreedFactorOffspring: '',
        birthDate: '',
        noOfBirth: null,
        noOfDeath: null,
        OffspringAdded: '',
        ubn: '',
        locationName: '',
        maleLeased: false,
        maleUBN: '',
        maleKeeperName: '',
        maleTagNumber: '',
        maleAnimalNumber: '',
        maleStudbookNumber: '',
        maleName: '',
        maleInbreedFactor: '',
    })
    return {
        state,
        displayText
    }    
  },    
  components: {      
    MaterialSwitch,
  },    
    async mounted() {  
      this.id = this.$route.params.id;         
      
      try {
            this.$store.commit('setShowLoading', true);
            
            await this.fetchMatingData(this.$route.params.id);            
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }      
    },
    methods: {        
      async fetchMatingData(groupGuid) {
        try {
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`mating/groupoverview/${groupGuid}`);
            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.mating = this.gets.data;
                
                this.state.dateFrom = this.state.mating.dateFrom;
                this.state.dateTo = this.state.mating.dateTo;
                this.state.inbreedFactorOffspring = this.state.mating.inbreedFactorOffspring;
                this.state.birthDate = this.state.mating.birthDate;
                this.state.noOfBirth = this.state.mating.noOfBirth;
                this.state.noOfDeath = this.state.mating.noOfDeath;

                this.state.OffspringAdded = this.state.mating.OffspringAdded;
                this.state.ubn = this.state.mating.ubn;
                this.state.locationName = this.state.mating.locationName;
                this.state.maleLeased = this.state.mating.maleLeased;
                this.state.maleUBN = this.state.mating.maleUBN;
                this.state.maleKeeperName = this.state.mating.maleKeeperName;
                this.state.maleTagNumber = this.state.mating.maleTagNumber;
                this.state.maleAnimalNumber = this.state.mating.maleAnimalNumber;
                this.state.maleStudbookNumber = this.state.mating.maleStudbookNumber;
                this.state.maleName = this.state.mating.maleName;
                this.state.maleInbreedFactor = this.state.mating.maleInbreedFactor;

            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      }            
    }
  };
  </script>
    <style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;    
    position: relative;
    padding: 10px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .bg-light {
    background-color: #f9f9f9 !important;
  }
  .border-success {
    border-color: #28a745 !important;
  }
</style>